import Swiper, { Autoplay, Navigation, Pagination, Keyboard } from 'swiper'
import 'swiper/swiper-bundle.css'
import './styles.scss'

Swiper.use([ Autoplay, Navigation, Pagination, Keyboard ])

const swiper = new Swiper('.baners-slider', {
    autoplay: true,
    delay: 4000,

    loop : true,
    
    navigation: {
        nextEl: '.baners-slider .swiper-button-next',
        prevEl: '.baners-slider .swiper-button-prev',
    },
    pagination: {
        el: '.baners-slider .swiper-pagination',
        clickable: true,
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
})

document.querySelectorAll('.baners__small-slider').forEach((swiperContainer) => {
    const swiperSmall =  new Swiper(swiperContainer, {
        autoplay: true,
        delay: 4000,
    
        loop : true,
        
        navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    })
})

document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        try {
            swiper.update()
        } catch (error) {
            
        }
    }, 300)
})

/*
const handleResizeWindow = () => {
    const windowWidth = window.innerWidth

    const bannerNovetly = document.querySelector('.baners__small-slider_top'), 
    bannerSale = document.querySelector('.baners__small-slider_bottom')

    const novetlyBannersContainer = document.querySelector('#novetly-banners'),
    saleBannersContainer = document.querySelector('#sale-banners')

    const bannersSmallContainer = document.querySelector('.baners__small')

    if (bannerNovetly && bannerSale && novetlyBannersContainer && saleBannersContainer && bannersSmallContainer) {
        if (windowWidth <= 720 && !bannerNovetly.parentNode.classList.contains('products-slider__baner')) {
            novetlyBannersContainer.appendChild(bannerNovetly)
            saleBannersContainer.appendChild(bannerSale)
        } else {
            bannersSmallContainer.appendChild(bannerNovetly)
            bannersSmallContainer.appendChild(bannerSale)
        }
    }
}

window.addEventListener('resize', () => {
    setTimeout(() => {
        handleResizeWindow()
    }, 100)
})
handleResizeWindow()
*/